import StageBuilder from "./stage/StageBuilder";

function App() {
  return (
    <div style={{ backgroundColor: "#1f2937", minheight: "100vh", overflow: "hidden" }}>
      <StageBuilder />
    </div>
  );
}

export default App;
